import React from 'react'
import CheckMark from './CheckMark'

const FeatureList = ({ list, t }) => (
    <ul>
        {list.map((feature, index) => (
            <li key={`desc-feature-${index}`}>
                <CheckMark color="#FFF" bgColor={feature.color} />
                <span>{t(feature.text)}</span>
            </li>
        ))}
    </ul>
)

export default FeatureList
